/*
* registreer in main.js
* */

const nl2br = {
  mounted: (el) => {
    let content = el.innerHTML
      .split('\n')
      .reduce((carry, string) => {
        return `${carry}<br />${string}`
      }, '')

    el.innerHTML = content
  }
}

export default nl2br

